import { render, staticRenderFns } from "./Faq_Comp.vue?vue&type=template&id=e2366664&scoped=true&"
import script from "./Faq_Comp.vue?vue&type=script&lang=js&"
export * from "./Faq_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Faq_Comp.vue?vue&type=style&index=0&id=e2366664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2366664",
  null
  
)

export default component.exports